import { genericThunkCreator2 } from 'app/actions/genericActionCreator'

export const submitInitialQuestionsForm = (formValues) => {
  const initialQuestionsRequest = {
    appraiserType: formValues.aappUsed === 'Yes' ? formValues.appraiserType : null,
    aappUsed: formValues.aappUsed === 'Yes',
    propertyAppraisalId: formValues.propertyAppraisalId
  }
  return genericThunkCreator2('ASSIGNMENT_DETAILS', `/lgyhub/api/appraiser-workspace/appraiser/${formValues.id}/property-appraisal/${formValues.lin}/aapp/initial-questions`,
    { method: 'POST', body: initialQuestionsRequest })
}
